module.exports = " <ul class=\"nav nav-{{navStyle}}\" role=tablist _v-0faa8558=\"\"> <template v-for=\"t in headers\"> <li v-if=!t._tabgroup :class=\"{active:t.active, disabled:t.disabled}\" @click.prevent=select(t) _v-0faa8558=\"\"> <a href=# _v-0faa8558=\"\"><slot name=header _v-0faa8558=\"\">{{{t.header}}}</slot></a> </li> </template> </ul> <div class=tab-content v-el:tab-content=\"\" _v-0faa8558=\"\"> <slot _v-0faa8558=\"\"></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-0faa8558!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Tabset.vue
// module id = 1132
// module chunks = 2